/* ==========================================================================
   STICK'IT — SKIN : BOUTIQUE + COLLECTIONS (additif, après stickit.js + skin.js)
   - compteur géant dans l'en-tête, recopié de [data-count] (aria-hidden)
   Ne touche à aucun écouteur, attribut data-* ni état d'initShop/initQuickview.
   ========================================================================== */
(function () {
  'use strict';
  var doc = document;
  var grid = doc.querySelector('[data-shop-grid]');
  var Skin = window.StickitSkin;
  if (!grid || !Skin) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Prix : affichés en police normale du site (plus de glyphes One Number sur les cartes) */

  /* 2. Compteur de l'en-tête : miroir décoratif de [data-count] */
  var count = doc.querySelector('[data-count]');
  var band = doc.querySelector('.strate-band .wrap');
  if (!count || !band || doc.querySelector('.sk-obs-hero')) return;   // pas de compteur sur Obsaners (il gâchait la photo)
  var dial = doc.createElement('div'); dial.className = 'sk-dial'; dial.setAttribute('aria-hidden', 'true');
  var num = doc.createElement('span'); num.className = 'sk-dial-n';
  var lab = doc.createElement('span'); lab.className = 'sk-dial-l';
  dial.appendChild(num); dial.appendChild(lab);
  band.appendChild(dial);
  var last = null;
  function sync() {
    var n = parseInt((count.textContent || '').replace(/\D/g, ''), 10) || 0;
    if (n === last) return;
    var first = last === null;
    last = n;
    num.removeAttribute('data-sk-glyphed');
    num.textContent = n < 10 ? '0' + n : String(n);
    Skin.glyph(num);
    lab.textContent = n > 1 ? 'pièces affichées' : n ? 'pièce affichée' : 'aucune pièce';
    if (!first && !reduced) { dial.classList.remove('sk-tick'); void dial.offsetWidth; dial.classList.add('sk-tick'); }
  }
  sync();
  new MutationObserver(sync).observe(count, { childList: true, characterData: true, subtree: true });
})();

/* Boutique : filtres compacts. Chaque groupe (Univers, Finition, Budget) devient un menu déroulant
   « Groupe : valeur ▾ » sur une seule ligne. Les pastilles d'origine sont déplacées dans le menu :
   leurs écouteurs (filtrage dans stickit.js) et leurs compteurs restent inchangés. */
(function () {
  'use strict';
  var doc = document;
  var bar = doc.querySelector('.sk-shop .filters');
  if (!bar) return;
  var rows = Array.prototype.slice.call(bar.querySelectorAll('.frow'));
  if (!rows.length) return;
  var drops = [];
  function close(except) {
    drops.forEach(function (d) { if (d !== except) { d.el.classList.remove('open'); d.btn.setAttribute('aria-expanded', 'false'); } });
  }
  rows.forEach(function (row, i) {
    var chips = Array.prototype.slice.call(row.querySelectorAll('.chip'));
    if (!chips.length) return;
    var lab = row.querySelector('.flab');
    var el = doc.createElement('div'); el.className = 'sk-fdd';
    var btn = doc.createElement('button'); btn.type = 'button'; btn.className = 'sk-fdd-btn';
    btn.setAttribute('aria-haspopup', 'true'); btn.setAttribute('aria-expanded', 'false');
    var val = doc.createElement('span'); val.className = 'sk-fdd-val';
    if (lab) btn.appendChild(lab);                 // libellé d'origine (traduit par i18n.js)
    btn.appendChild(val);
    var panel = doc.createElement('div'); panel.className = 'sk-fdd-panel'; panel.id = 'sk-fdd-' + i;
    btn.setAttribute('aria-controls', panel.id);
    chips.forEach(function (c) { panel.appendChild(c); });
    el.appendChild(btn); el.appendChild(panel);
    row.insertBefore(el, row.firstChild);
    row.classList.add('sk-dd');
    var d = { el: el, btn: btn, val: val, chips: chips };
    drops.push(d);
    btn.addEventListener('click', function (ev) {
      ev.stopPropagation();
      var open = !el.classList.contains('open');
      close(d); el.classList.toggle('open', open); btn.setAttribute('aria-expanded', String(open));
    });
    panel.addEventListener('click', function (ev) {
      if (!ev.target.closest('.chip')) return;
      setTimeout(function () { sync(); close(); btn.focus(); }, 0);   // après le filtrage de stickit.js
    });
  });
  function sync() {
    drops.forEach(function (d) {
      if (!d.chips) return;                         // la bulle « Trier » (ajoutée plus bas) a sa propre synchro
      var on = d.chips.filter(function (c) { return c.classList.contains('on'); })[0] || d.chips[0];
      var t = '';
      Array.prototype.forEach.call(on.childNodes, function (n) { if (n.nodeType === 3) t += n.textContent; });
      d.val.textContent = t.trim();
      d.el.classList.toggle('active', on.getAttribute('data-v') !== 'all');
    });
  }
  sync();
  // réinitialisation, retour arrière (états restaurés) et changement de langue
  var reset = bar.querySelector('[data-freset]');
  if (reset) reset.addEventListener('click', function () { setTimeout(sync, 0); });
  drops.forEach(function (d) { d.chips.forEach(function (c) { new MutationObserver(sync).observe(c, { attributes: true, attributeFilter: ['class'], childList: true, characterData: true, subtree: true }); }); });
  doc.addEventListener('click', function (ev) { if (!ev.target.closest('.sk-fdd')) close(); });
  doc.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') close(); });

  /* Tri : le <select class="sort"> devient une bulle « Trier ▾ » comme les filtres. Le select reste
     (masqué) : un choix y écrit la valeur puis déclenche « change », le tri de stickit.js est inchangé. */
  var sel = doc.querySelector('.sk-shop select.sort');
  if (sel) {
    var sEl = doc.createElement('div'); sEl.className = 'sk-fdd sk-fdd-sort';
    var sBtn = doc.createElement('button'); sBtn.type = 'button'; sBtn.className = 'sk-fdd-btn';
    sBtn.setAttribute('aria-haspopup', 'true'); sBtn.setAttribute('aria-expanded', 'false'); sBtn.setAttribute('aria-controls', 'sk-fdd-sort');
    var sLab = doc.createElement('span'); sLab.className = 'flab'; sLab.textContent = 'Trier';
    var sVal = doc.createElement('span'); sVal.className = 'sk-fdd-val';
    sBtn.appendChild(sLab); sBtn.appendChild(sVal);
    var sPanel = doc.createElement('div'); sPanel.className = 'sk-fdd-panel'; sPanel.id = 'sk-fdd-sort';
    var sChips = Array.prototype.map.call(sel.options, function (o) {
      var c = doc.createElement('button'); c.type = 'button'; c.className = 'chip'; c.setAttribute('data-sort', o.value);
      c.textContent = o.value === 'def' ? 'Mis en avant' : o.textContent.trim();   // le libellé du bouton dit déjà « Trier »
      sPanel.appendChild(c);
      return c;
    });
    sEl.appendChild(sBtn); sEl.appendChild(sPanel);
    sel.parentNode.insertBefore(sEl, sel);
    sel.classList.add('sk-sort-native');
    var sd = { el: sEl, btn: sBtn };
    drops.push(sd);                                  // fermeture commune avec les filtres (clic dehors, Échap)
    var sSync = function () {
      var on = sChips.filter(function (c) { return c.getAttribute('data-sort') === sel.value; })[0] || sChips[0];
      sChips.forEach(function (c) { c.classList.toggle('on', c === on); });
      sVal.textContent = sel.value === 'def' ? '' : on.textContent;
      sEl.classList.toggle('active', sel.value !== 'def');
    };
    sBtn.addEventListener('click', function (ev) {
      ev.stopPropagation();
      var open = !sEl.classList.contains('open');
      close(sd); sEl.classList.toggle('open', open); sBtn.setAttribute('aria-expanded', String(open));
    });
    sPanel.addEventListener('click', function (ev) {
      var c = ev.target.closest('.chip');
      if (!c) return;
      sel.value = c.getAttribute('data-sort');
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sSync(); close(); sBtn.focus();
    });
    sel.addEventListener('change', sSync);
    sSync();
  }
})();
/* Page Collections : vues ambassadeurs (Obsaners et suivants). Chaque <section class="sk-amb" data-amb data-amb-label>
   devient un bouton de sélection ; une seule vue affichée à la fois. Chaque vue a sa collection Shopify et son adresse
   (data-amb-url, ex. /collections/obsaners) ; l'ancien lien ?amb=<slug> reste accepté.
   Ajouter un ambassadeur = créer la collection (modèle « obsaners-collection ») + une section dans le template. */
(function () {
  'use strict';
  var doc = document;
  var nav = doc.querySelector('[data-amb-nav]');
  var views = Array.prototype.slice.call(doc.querySelectorAll('.sk-amb[data-amb]'));
  if (!nav || views.length < 2) return;
  var list = doc.createElement('div'); list.className = 'sk-amb-tabs wrap'; list.setAttribute('role', 'tablist');
  var label = doc.createElement('span'); label.className = 'sk-amb-k'; label.textContent = 'Ambassadeurs';
  nav.appendChild(label); nav.appendChild(list);
  var tabs = views.map(function (v) {
    var slug = v.getAttribute('data-amb');
    var b = doc.createElement('button'); b.type = 'button'; b.className = 'sk-amb-tab'; b.setAttribute('role', 'tab');
    b.id = 'amb-tab-' + slug; b.setAttribute('aria-controls', v.id); b.setAttribute('data-amb-go', slug);
    b.innerHTML = '<span>' + (v.getAttribute('data-amb-label') || slug) + '</span>';
    v.setAttribute('role', 'tabpanel'); v.setAttribute('aria-labelledby', b.id);
    list.appendChild(b);
    return b;
  });
  var current = null;
  function show(slug, opts) {
    opts = opts || {};
    var i = -1; views.forEach(function (v, k) { if (v.getAttribute('data-amb') === slug) i = k; });
    if (i < 0) i = 0;
    var next = views[i].getAttribute('data-amb');
    if (next === current) return;
    current = next;
    views.forEach(function (v, k) {
      var on = k === i;
      v.hidden = !on; v.classList.toggle('is-active', on);
      tabs[k].setAttribute('aria-selected', on ? 'true' : 'false'); tabs[k].tabIndex = on ? 0 : -1;
      tabs[k].classList.toggle('on', on);
      Array.prototype.forEach.call(v.querySelectorAll('video'), function (vid) {
        if (on) { var p = vid.play && vid.play(); if (p && p.catch) p.catch(function () {}); } else if (vid.pause) vid.pause();
      });
    });
    doc.body.setAttribute('data-amb', current);
    // chaque ambassadeur a sa propre adresse (/collections/obsaners) : l'URL et le titre suivent la vue
    var title = views[i].getAttribute('data-amb-title');
    if (title) doc.title = title;
    var url = views[i].getAttribute('data-amb-url');
    if (opts.url !== false && url) {
      try {
        var u = new URL(location.href); u.searchParams.delete('amb');
        if (u.pathname !== url) history[opts.replace ? 'replaceState' : 'pushState']({ amb: current }, '', url + u.search);
        else if (opts.replace) history.replaceState({ amb: current }, '', url + u.search + u.hash);
      } catch (e) {}
    }
    if (opts.scroll && nav.classList.contains('is-stuck')) {
      // changement depuis le bas de page : on revient au début de la nouvelle vue, sous la barre collée
      var y = views[i].getBoundingClientRect().top + window.scrollY - nav.getBoundingClientRect().bottom;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
    if (opts.focus) tabs[i].focus();
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-amb-go]');
    if (!b) return;
    show(b.getAttribute('data-amb-go'), { scroll: true });
  });
  list.addEventListener('keydown', function (e) {
    var k = tabs.indexOf(doc.activeElement); if (k < 0) return;
    var n = e.key === 'ArrowRight' ? k + 1 : e.key === 'ArrowLeft' ? k - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
    if (n === null) return;
    e.preventDefault(); n = (n + tabs.length) % tabs.length;
    show(views[n].getAttribute('data-amb'), { focus: true });
  });
  // barre collée sous l'en-tête fixe : hauteur réelle de l'en-tête (varie sur mobile), ombre une fois collée
  var head = doc.querySelector('.site-head');
  var setTop = function () { if (head) nav.style.setProperty('--amb-top', Math.round(head.getBoundingClientRect().bottom) + 'px'); };
  setTop(); window.addEventListener('resize', setTop);
  var stuck = function () { nav.classList.toggle('is-stuck', nav.getBoundingClientRect().top <= parseFloat(getComputedStyle(nav).top) + 1); };
  window.addEventListener('scroll', stuck, { passive: true }); stuck();
  // précédent / suivant du navigateur : on réaffiche la vue de l'adresse
  window.addEventListener('popstate', function () {
    var p = location.pathname, s = null;
    views.forEach(function (v) { if (v.getAttribute('data-amb-url') === p) s = v.getAttribute('data-amb'); });
    if (s) show(s, { url: false });
  });
  // vue de départ : celle de l'adresse (rendue côté serveur) ; l'ancien lien ?amb=<slug> est converti en adresse propre
  var box = doc.querySelector('[data-amb-views]');
  var q = null; try { q = new URL(location.href).searchParams.get('amb'); } catch (e) {}
  show(q || (box && box.getAttribute('data-amb-default')) || views[0].getAttribute('data-amb'), { url: !!q, replace: true });
})();
